// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1PCZK","content":"ManualTimeModal_content__1yH_-"};